import React, { useState } from "react";
import GCV_table from "./gcv_table/GCV_table";
import GCV_Form from "./gcv_Form/GCV_Form";


function GCV({ onNext, onCancel }) {
  return (
    <section className="Imperiality">
      <div className="imperiality_Form_div">
        <GCV_Form onCancel={onCancel} onNext={onNext}/>
      </div>

      <div className="imperiality_table_div">
        <GCV_table />
      </div>
    </section>
  );
}

export default GCV;
